module.exports = __webpack_public_path__ + "static/media/intro-side.215c81d1.png";